// TreatmentsListByStation.js


import { Grommet, Box, Button, TextInput, Layer, Text,  Spinner, RadioButton} from "grommet";
import { FastForward, Achievement, Trophy, Cycle, UserExpert, Dislike} from "grommet-icons";
import { useState, useEffect, useContext, useRef} from "react";
import { useFetch } from "use-http";
import { getDBURL, convertDateToDisplayformat, correctTimeZone, generateSyncId, usePopupFocus } from "../Utils/Utils";
import useTrapFocus from "../Utils/useTrapFocus";
import { UserContext } from "../../App";
import { useNavigate } from "react-router-dom";
import EvaluationForTreatment from "../Base components/EvaluationForTreatment";
import ConfirmPopupWindow from "../Base components/ConfirmPopupWindow";
import { useErrorLogger } from './Logger';

const customTheme = {
    radioButton: {
        border: {
            color: '#00739D', // Default border color for the outer circle when unchecked
            width: '2px',
        },
        hover: {
            border: {
            color: "#047343", // Outer circle border color on hover
            },
        },
        size: '26px', // Size of the outer circle
        gap: 'small', // Space between the radio button and label
        icon: {
            size: '16px', // Inner circle size (checked state)
        },
        check: {
            color: '#047343', // Inner circle (dot) color when checked
        },
        extend: `
            input[type="radio"]:checked + div {
                border-color: #047343; /* Outer circle color when checked */
            }
            // input[type="radio"]:checked + div > div {
            //   background-color: #047343; /* Inner circle (dot) background when checked */
            // }
        `,
        },
  };
  
  
const TreatmentsListByStation = (props) => {
    // console.log('In TreatmentsListByStation props >> ', props);

    const { station, stationStartRow, allStationTreatments, finishScionTreatment, openTreatment, setAddTreatmentsPopupOpen
            , bestTreatmentNum, setBestTreatmentNum, bestTreatmentBy, setBestTreatmentBy, deleteDisqualReason
            , showTreatmentsMultiYearSummary, setShowTreatmentsMultiYearSummary
    } = props;
    const currentUser = useContext(UserContext);
    const [loading, setLoading] = useState(true);
    const {  post} = useFetch(getDBURL());
    const navigate = useNavigate();
    const { DBlogError } = useErrorLogger();

    const [treatmentsList, setTreatmentsList]= useState([]);   // list of treatments  
    const [selectedTreatment, setSelectedTreatment]= useState({treatmentID: "0", treatmentName: '', treatmentStatus: null, plantsStatus: null});   // list of treatments   
    const [showEvaluationForTreatment, setShowEvaluationForTreatment] = useState(false);

    const [showConfirmPopup, setShowConfirmPopup] = useState(false);    // Confirm Popup Window
    const [confirmMessage, setConfirmMessage] = useState('');
    const [confirmFuncOnConfirm, setConfirmFuncOnConfirm] = useState('');

    // Ref for the modal and focus trap to keep focus within it  
    const modalRef = useRef(null);
    useTrapFocus(modalRef, true); // Trap focus inside the modal while it's open

    // Manage focus when opening modal windows
    usePopupFocus(showEvaluationForTreatment, "evals-for-treat");
    usePopupFocus(showConfirmPopup, "confirm-msg");  


    useEffect(() => {
        (async function loadTreatmentList() {
            // console.log('In loadTreatmentsByStation stationNum >> ', station.Id);
            try {
                // console.log('loaded Treatments By Station >> ', allStationTreatments);
                if (allStationTreatments !== undefined && allStationTreatments.length > 0) {
                    let temp = [];
                    let previous = null;
                    allStationTreatments.map((treatment) => {

                        temp.push ({
                            sheetNum: treatment.SheetNum,
                            treatmentID: treatment.TreatmentId, // === null ? 0 : treatment.TreatmentId,
                            treatmentName: treatment.TreatmentName === '' && treatment.TreatmentStatus === null ? "vines are not part of any group"
                                : treatment.TreatmentName === '' && treatment.TreatmentStatus !== null ? "without name" : treatment.TreatmentName,
                            treatmentStatus: treatment.TreatmentStatus,
                            treatmentColor:
                                treatment.TreatmentStatus === 5 
                                    ? "#639263" //"status-ok"
                                    : treatment.TreatmentStatus === 4 
                                        ? "#FFAA15"  // "accent-4"
                                        : treatment.TreatmentStatus === 3 
                                        ? "#61aec9" 
                                        : "#666666", // "status-unknown",
                            treatmentStartDate: treatment.TreatmentCreateDate,
                            treatmentFinishDate: treatment.TreatmentFinishDate,
                            treatmentPlantsStatusId: treatment.PlantsStatusId,
                            treatmentPlantsStatus: treatment.PlantsStatus,
                            treatmentDisqualified: treatment.IsDisqualified,
                            trscionId: treatment.TrScId,
                            scion: treatment.ScionColumn,
                            scionStartDate: treatment.ScionAddDateToTreatment,
                            scionEndDate: treatment.ScionRemoveDateFromTreatment,
                            countOfEval: treatment.CountEvaluations,
                            grade: treatment.Grade,
                            // evaluationDate: treatment.EvaluationDate,
                            // evaluationProgress: treatment.EvaluationProgress,
                            average: null,  //(grade !== null ? grade / count : null)
                        })                      
                        previous = treatment;
                    });
                    // console.log('in useEffect temp >> ', temp);
                    setTreatmentsList(temp);
                }
            }
            catch (error) {
                console.log('in loadTreatmentList error: ' + error.message);
            }
        } ) ()
    }, [allStationTreatments]);

    /*  The function getTreatmentById will return the first treatment object that matches the given treatmentID.
        If no matching treatment is found, .find() will return undefined.  **/
    function getTreatmentById(treatmentID) {
        return treatmentsList.find(treatment => treatment.treatmentID === treatmentID);
    };    

    // hides the "Confirm" popup window 
    const onCloseConfirmWindow = () => {
        setShowConfirmPopup(false);
    };

    const openConfirmWindow = (msg, func) => {
        setConfirmMessage(msg);
        setConfirmFuncOnConfirm(() => func); // Store the callback function without executing it        
        setShowConfirmPopup(true);
    };

    // hides the "Confirm" popup window 
    const closeConfirmWindow = () => {
        setShowConfirmPopup(false);
        setConfirmMessage('');    
    };

    // fires when the "Confirm" button is clicked in the "Confirm" popup
    const onConfirm = (evaluation) => {
        if (typeof confirmFuncOnConfirm === 'function') {
            confirmFuncOnConfirm();
        }       

        closeConfirmWindow();
        setConfirmFuncOnConfirm('');
    };

    const updatePlantStatus = async ( treatment, status, seeded) => {
        try {
            const statusForYearExist = treatment.treatmentPlantsStatusId === null ? false : true;

            let values = null;
            if (!statusForYearExist) {
                // insert values
                values = {
                    Id: generateSyncId(),
                    TreatmentId: treatment.treatmentID,
                    StationId: station.Id,
                    Status: status,
                    IsSeeded: seeded === undefined ? null : seeded,
                    CreateDate: correctTimeZone(new Date()),
                    CreatedBy: currentUser.email,
                    Year: new Date().getFullYear(),                    
                    LastSyncDate: correctTimeZone(new Date()),
                };
            } else {
                // update values
                values = {
                    Id: treatment.treatmentPlantsStatusId,
                    TreatmentId: treatment.treatmentID,
                    StationId: station.Id,
                    Status: status,
                    StatusUpdatedAt: correctTimeZone(new Date()),
                    StatusUpdatedBy: currentUser.email,                    
                    IsSeeded: seeded === undefined ? -1 : seeded,
                    SeededUpdatedAt: correctTimeZone(new Date()),
                    SeededUpdatedBy: currentUser.email,                    
                    LastSyncDate: correctTimeZone(new Date()),
                };
            }
            // console.log('In updatePlantStatus values  >>>   ', values);
            const response = await post(`/updatePlantStatus/dt=${Date.now()}`, values);  
            
            // Check if the response is successful
            if (!response.success) {
                // console.log("In updatePlantStatus response   >> ", response.message); 
                throw new Error(`HTTP error! ${response.message}`);
            }                         

        } catch (error) {
            console.error(' 🔴 Error in updatePlantStatus >> ', error.message);
            await DBlogError({
                error,
                parameters: JSON.stringify({ treatment }),
                userName: currentUser.email,
                moduleName: 'TreatmentsListByStation',
                functionName: 'updatePlantStatus',
            });
        }
    };

    /*  Handles setting the best treatment and opens a confirmation popup if needed
        when radiobutton clicked  **/
        const updateBest = (treatment) => {
            // console.log('bestEvaluationBy >> ', bestEvaluationBy);
    
            const isAnotherTreatment = treatment.treatmentID !== bestTreatmentNum;
            const isAutoSelection = bestTreatmentBy === 'auto';
    
            if (isAnotherTreatment) {
                if (isAutoSelection) {
                    openConfirmWindow(
                        `This action will disable automatic selection of the best treatment based on the highest grade. Please confirm to proceed.`,
                        () => updateBestTreatment(treatment)
                    );
                } else {
                    updateBestTreatment(treatment);
                }
            } else {
                if (isAutoSelection) {
                    openConfirmWindow(
                        `This action will disable automatic selection of the best treatment based on the highest grade. Please confirm to proceed.`,
                        () => updateBestTreatment(treatment)
                    );
                } else {
                    openConfirmWindow(
                        `This action will cancel any manual selection of the best treatment and switch back to automatically selecting.`,
                        () => cancelManualSelectionBestTreatment(treatment)
                    );
                }
            }
        };

        /*  user cancels manually selection the best treatment 
        and returns to automatic selection the best teatment based on the highest grade.  **/
        const cancelManualSelectionBestTreatment = async (treatment) => {
            updateBestTreatment(treatment);
            updateBestTreatmentAuto();
        };        

        const updateBestTreatmentAuto = async() => {
            // console.log('In updateBestTreatmentAuto function');
            // console.log('station id >>>  ', station.Id);
            // console.log('station >>>  ', station);
            // console.log('treatment id >>>  ', treatmentId);
            try {
                const updateTreatmentValues = {
                    Id: generateSyncId(),
                    StationId: station.Id,
                    BestTreatmentYear: new Date().getFullYear(),
    
                    // Compute the BestTreatmentId as the highest-graded evaluation from VEM_BestEvaluationForTreatment.
                    BestTreatmentId: 'FFFFFFFF-FFFF-FFFF-FFFF-FFFFFFFFFFFF',
                    BestTreatmentDate: correctTimeZone(new Date()),
                    BestTreatmentBy: 'auto',
                };
                
                const response = await post(`/updateStationBestTreatment/dt=${Date.now()}`, updateTreatmentValues);
    
                if (!response.success) {
                    throw new Error(`${response.message}`);
                }
                // console.log('Return Value - Success status code (1, 2, etc.): ', response.returnValue); // Success status code (1, 2, etc.)
                // console.log('Best Treatment ID returned from the SQL procedure: ', response.result.BestTreatmentId); // The BestTreatmentId returned from the procedure
                // console.log('Best Treatment By: ', updateTreatmentValues.BestTreatmentBy);
                setBestTreatmentNum(response.result.BestTreatmentId);
                setBestTreatmentBy(updateTreatmentValues.BestTreatmentBy);

            } catch (error) {
                console.error('🔴 Error in updateBestEvaluationAuto:', error.message);
    
                // Construct error object
                const errorDetails = {
                    error: error,
                    parameters: { StationId: station.Id, TreatmentId: 'FFFFFFFF-FFFF-FFFF-FFFF-FFFFFFFFFFFF', Year: new Date().getFullYear() },
                    userName: currentUser.email,
                    moduleName: 'TreatmentsListByStation',
                    functionName: 'updateBestTreatmentAuto',
                };
                await DBlogError(errorDetails);
            }
        };

    /*  The setBestTreatment function updates the best treatment for a specific station. 
        It either sets a new best treatment based on the provided treatment ID 
        or unsets the current best treatment if the treatment ID is null.

        Parameters:    
        treatmentID (UUID or null): The ID of the treatment to set as the best treatment for the station. 
        If null, the function will unset the current best treatment. **/
    const updateBestTreatment = async (treatment) => {
        // console.log('In updateBestTreatment function');
        // console.log('bestTreatmentNum >  ', bestTreatmentNum);
    
        // Determine the new treatment ID and whether to set or unset it
        // const shouldUpdate = treatment.treatmentID !== bestTreatmentNum; 
        let updateValues = null;
        try {
            // Prepare the update object
            
            if (treatment.treatmentID !== bestTreatmentNum) {
                // set the best treatment by user
                updateValues = {
                    Id: generateSyncId(),
                    StationId: station.Id,
                    BestTreatmentYear: new Date().getFullYear(),                    
                    BestTreatmentId: treatment.treatmentID,
                    BestTreatmentDate: correctTimeZone(new Date()),
                    BestTreatmentBy: currentUser.email,
                }
            } else {
                // cancel the best treatment by user and returns to automatic selection
                updateValues = {
                    StationId: station.Id,
                    BestTreatmentYear: new Date().getFullYear(),
                    BestTreatmentId: null,
                    BestTreatmentDate: correctTimeZone(new Date()),
                    BestTreatmentBy: 'auto',
                };
                if (bestTreatmentBy === 'auto') {
                    // console.log('switch the selection of the best treatment from  auto to manual  ');
                    updateValues.BestTreatmentId = treatment.treatmentID;
                    updateValues.BestTreatmentBy = currentUser.email;
                }
            }

            // Send the update request
            const response = await post(`/updateStationBestTreatment/dt=${Date.now()}`, updateValues);
            if (!response.success) {
                throw new Error(`${response.message}`);
            }
            
            // Update the state based on whether we are setting or unsetting the treatment
            // setBestTreatmentNum(shouldUpdate ? treatmentNum : null);
            setBestTreatmentNum(response.result.BestTreatmentId);
            setBestTreatmentBy(updateValues.BestTreatmentBy);
            
        } catch (error) {
            console.log('🔴 Error in updateBestTreatment: ', error.message);
    
            // Construct error object
            const errorDetails = {
                error: error,
                parameters: { StationId: station.Id, TreatmentId: 'FFFFFFFF-FFFF-FFFF-FFFF-FFFFFFFFFFFF', Year: new Date().getFullYear() },
                userName: currentUser.email,
                moduleName: 'TreatmentsListByStation',
                functionName: 'updateBestTreatmentAuto',
            };
            await DBlogError(errorDetails);
        }
    };
    
    /*  The function iterates through an array of treatment objects (treatmentsList) 
        and calculates the average grade for each group of treatments that share the same treatmentID. 
        The average grade is then assigned to the last treatment in each group with the average property. 
        If a treatment has no grade (null), it is skipped in the average calculation.  **/
    const CalcAverage = () => {
        if (treatmentsList.length === 0)
            return;

        // Initialize a variable to store the previous item's ID
        let previousItem = null;
        let grade = null;
        let count = null;      

        treatmentsList.map((item, index) => {
            if (previousItem !== null && item.treatmentID === previousItem.treatmentID) {

                if (item.grade !== null) {
                        grade += item.grade;
                        count++;
                } 
            } else {
                // next treatment
                if (previousItem !== null && grade !== null)
                    treatmentsList[index - 1].average = grade / count; 

                if (item.grade !== null) {
                    grade = item.grade;
                    count = 1;
                }
                else {
                    grade = null;
                    count = null;                    
                }            
            }

            // last item
            if (index === treatmentsList.length - 1 && grade !== null)
                item.average = grade / count;

            // Update the previousItem variable for the next iteration
            previousItem = item;    
        });
    }

    useEffect(() => {
        // console.log("Re-rendering due to bestTreatmentNum:", bestTreatmentNum);    
        DrawTable();
    }, [treatmentsList, bestTreatmentNum]); 

    useEffect(() => {
        // console.log('in useEffect !! ');                
        DrawTable();
    
        const timeoutId = setTimeout(() => {
            setLoading(false); // Set loading to false after 1 seconds
        }, 1000); // 1 seconds in milliseconds
    
        // Cleanup the timeout on component unmount or when the dependency changes
        return () => clearTimeout(timeoutId);
    }, [treatmentsList]);

    const DrawTable = () =>
    {
        if (treatmentsList.length === 0)
            return;

        CalcAverage();


        // console.log('treatmentsList >> ', treatmentsList);
        const rows = [];
        let lastTreatmentPrinted = null;
        let counter = 0;

        treatmentsList.map((item) => {
            rows.push(DrawRow(item, lastTreatmentPrinted));
            lastTreatmentPrinted = item;
        });
        return rows;
    } 


    const DrawRow = (treatment, prev) =>
    {
        // console.log('treatment >> ', treatment);
   
        const next = (prev === null) || ((prev !== null) && (treatment.treatmentID !== prev.treatmentID));

        return(     

            <Box  key={Math.random(Date.now())}  align="center"  margin="xxsmall" >
                {treatment.treatmentID === null
                ? <Box width="100%"  align="center" 
                        pad={{ vertical: "small" }}                        
                        style={prev !== null ? {paddingTop: "50px"} : {paddingTop: "10px"}}
                    > 
                    <Box width="100%"  direction="row-responsive">
                        <Box direction="row" height="30px" margin='xxsmall'>  
                        </Box>
                        <Box pad="xxsmall" width= "350px" height="30px" >
                            <Button 
                                color="#33333310"
                                style={{color: "#AA3747", padding: 0, fontSize: "18px"}}
                                primary                            
                                label={treatment.treatmentName } 
                            />
                        </Box> 
                    </Box> 
                    <Box width="100%"  direction="row-responsive"> 
                    <Box   direction="row"  justify="start"  style={{color: "#AA3747"}}>
                        <Box pad="xxsmall" width= "70px"></Box> 
                        <Box width= "20px"  margin="auto">
                            <FastForward  color="#AA3747" size='15px' />                                
                        </Box>   
                        <Box  direction="row" >
                            <Text >&nbsp;vines:&ensp;</Text>
                            <Text weight="bold" style={{fontStyle: "italic"}} >{treatment.scion}</Text>                    
                        </Box>
                    </Box>
                    </Box>

                </Box> 
                : <>
                    { next &&
                    <Box width="100%"  direction="row-responsive" align="center" 
                        pad={{ vertical: "small" }}                        
                        style={prev !== null ? {paddingTop: "50px"} : {paddingTop: "10px"}}
                    > 

                       
                        <Box width={{ width: '380px', min: '380px' }} direction="row" >  
                            <Box direction="row" width = "50px" height="30px" margin='xsmall' justify="end">
                                {treatment.treatmentDisqualified === 1
                                ?(
                                    <Dislike weight="bold" color="status-critical"/> 
                                )
                                :(  
                                    bestTreatmentNum !== null && treatment.treatmentID === bestTreatmentNum &&
                                    (<Box direction="row" width = "100%" justify="between">
                                        {(bestTreatmentBy === 'auto' )
                                        ? ( <Cycle  color="#047343" /> )
                                        : ( <UserExpert  color="#047343" /> )}
                                        <Trophy weight="bold"                             
                                        color="#047343"
                                        />
                                    </Box>  )                            
                                )}                                                         
                            </Box>  
                            <Grommet theme={customTheme}>                      
                            <Box direction="row" height="30px" margin='xxsmall'>  
                                <RadioButton
                                    name="radio"
                                    hoverIndicator
                                    checked={bestTreatmentNum === treatment.treatmentID}
                                    onChange={() => {}}
                                    onClick={() => updateBest(treatment)}
                                    disabled={treatment.treatmentDisqualified === 1}

                                />                                                                                       
                            </Box>
                            </Grommet>

                            <Box pad="xxsmall" width= "220px" height="30px" >
                                <Button 
                                    color={treatment.treatmentDisqualified === 1 ? "#ffe0cf" : "#33333310"}
                                    style={{color: treatment.treatmentColor, padding: 0, fontSize: "18px"}}
                                    primary                            
                                    label={treatment.treatmentName}
                                    onClick={() => {
                                        if (treatment.treatmentID !== null && treatment.treatmentID !== '00000000-0000-0000-0000-000000000000') 
                                            openTreatment(treatment)
                                        } }
                                    />
                            </Box> 
                        </Box>
                   
                        <Box  width="220px"  direction="row">                            
                            {treatment.treatmentStartDate !== null ? <Text >&nbsp;start:&ensp;</Text> : ""}
                            <Text weight="bold" style={{fontStyle: "italic"}} >{treatment.treatmentStartDate}</Text>                    
                        </Box> 
                        <Box  width="220px"  direction="row" >
                            {treatment.treatmentFinishDate !== null ? <Text >&nbsp;finish:&ensp;</Text> : ""}
                            <Text weight="bold" style={{fontStyle: "italic"}} >{treatment.treatmentFinishDate}</Text>                    
                        </Box>
                        <Box  width="220px"  direction="row">
                            {/* <Text weight="bold" style={{fontStyle: "italic"}} >{treatment.treatmentStatus}  {treatment.countOfEval}</Text>  */}
                            <Button 
                                color='brand'
                                style={{color: 'white', padding: 2, fontSize: "18px", width:'200px'}}
                                primary                            
                                // label='add eval'
                                // onClick={() => openSheet(null, treatment.treatmentID) }          
                                label='view evaluations'
                                onClick={() => {
                                    setSelectedTreatment({
                                        treatmentID: treatment.treatmentID,
                                        treatmentName: treatment.treatmentName,
                                        treatmentStatus: treatment.treatmentStatus, 
                                        plantsStatus: treatment.treatmentPlantsStatus
                                    }); 
                                    setShowEvaluationForTreatment(true);} }                         
                            />                                                           
                        </Box>
                    </Box> 
                    }

                    {/* {treatment.treatmentID !== 0 */}

                    <Box width="100%"  direction="row-responsive"> 
                        <Box width={{ width: '550px', min: '550px' }} direction="row" >
                            <>
                            <Box pad="xxsmall" width= "100px"></Box> 
                            <Box width= "30px"  margin="auto" >
                                <FastForward  color="brand" size='15px' />                                
                            </Box>   
                            <Box  width="150px"  direction="row" >
                                <Text >&nbsp;vine:&ensp;</Text>
                                <Text weight="bold" style={{fontStyle: "italic"}} >{treatment.scion}</Text>                    
                            </Box> 

                                <Box  width="250px"  direction="row" >
                                    <Text >&nbsp;start:&ensp;</Text>
                                    <Text weight="bold" style={{fontStyle: "italic"}} >{treatment.scionStartDate}</Text>                    
                                </Box> 
                                {treatment.scionEndDate !== null ?
                                <Box  width="220px"  direction="row" >
                                    <Text >&nbsp;end:&ensp;</Text>
                                    <Text weight="bold" style={{fontStyle: "italic"}} >{treatment.scionEndDate}</Text>                    
                                </Box> 
                                : 
                                <Box width= "220px" justify="start">
                                    <Box  width= "100px" height="26px" >
                                        <Button 
                                            color="#f0869c"
                                            style={{color: 'white', padding: 0, fontSize: "18px"}}
                                            primary                            
                                            label='remove'
                                            onClick={() => finishScionTreatment(treatment.trscionId) }
                                            />
                                    </Box>
                                </Box>                          
                                }
                            </>
                            
                        </Box> 
                    </Box>

                    {treatment.average !== null &&
                    <Box width="100%" > 
                        <Box background="neutral-3" width="90%" align="start" height="2px" margin={{vertical: "small", left: "70px"}} > </Box>
                        <Text weight="bold" style={{fontStyle: "italic", paddingLeft: "60px"}} > Treatment Max Grade: {(treatment.average.toFixed(2))}</Text>
                    </Box>
                    }
                </>
        }
        </Box>    
        );
    }


    const style = {
        border: "2px solid",       
        margin: "10px",
    };

    return (   
        <Layer
            id="treat-list"
            position="center"
            ref={modalRef}
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
         >
            
            {showConfirmPopup && (
            <ConfirmPopupWindow
                msg={confirmMessage}
                onClose={onCloseConfirmWindow}
                onConfirm={onConfirm}
            />)}

            <Box width="auto" height="100%" style={style}  pad="small"  background="light-3" >
                <Box
                    width="100%"
                    direction={treatmentsList.length > 1 ? "row-responsive" : "column"}
                    justify={treatmentsList.length > 1 ? "center" : undefined}
                    align="center"
                    margin="20px"
                    >
                    <Text weight="bold"
                        style={{ fontSize: "24px",
                            background: "linear-gradient(to left, #00739D, #f9dd94 100%)",
                            backgroundPosition: "0 100%",
                            backgroundSize: "100% 2px",
                            backgroundRepeat: "repeat-x",
                            padding: "10px 0", // Add margin for spacing
                            fontStyle: "italic"}}
                            >
                             Treatment List for <span style={{ fontWeight: "bold", fontSize: "30px", color:'#FFAA15'}}>
                            {station.Name}
                        </span>{" "} Station
                    </Text>

                    {/* summary button */} 
                    {!loading &&
                    <Box 
                    style={
                        treatmentsList.length > 1
                          ? { position: "absolute", right: "8%", top: "40px" }
                          : { padding: "20px 0 0 0" }
                      }
                    >
                        <Box  pad="small" align="center" justify="between">
                        <Button 
                            tip={
                                {
                                content: (
                                    <Box style={{
                                //     background: "rgba(204, 204, 204, .6)",
                                        background: "WhiteSmoke",
                                        border: "1px solid #00739D",
                                        borderRadius: "8px",
                                        padding: "5px",
                                        fontSize: "16px",
                                        fontWeight: "bold"
                                        }}>
                                        Multi-Year Evaluations Summary
                                    </Box>
                                ),
                                }
                            }

                            label="summary" 
                            style={{padding: "0px 0px 2px 0px", width: "150px"}}
                            onClick={() => setShowTreatmentsMultiYearSummary(true)} 
                        />   
                        </Box>                         
                    </Box>
                    }
                    {/* end of summary button part */}
                </Box>                

                {/* start table */}
                <Box width='97%' 
                    margin="small" 
                    pad="small"
                    border>

                    {loading &&
                    (<Box align="center" pad="small" gap="small" round="full">
                        <Spinner size="medium" /> <Text>Loading...</Text>
                    </Box> )
                    }
                    {!loading &&
                    <Box flex={true} align='center' background='light-1' overflow='auto'  >
                        <Box flex={false} height="auto" style={{ height: 'auto' }} >
                        {treatmentsList.length > 1 &&  // Always includes at least one where scions that are not yet in which treatment group
                            <Box  width="220px"  direction="row" margin="xxsmall">
                            <Text weight='bold' color="#047343">&emsp;&emsp;best&nbsp;&nbsp;&nbsp;&nbsp;</Text>
                            </Box>
                        }
                        {DrawTable()}
                        </Box>
                    </Box>
                    }
                </Box>
                {/* end table */}

                {showEvaluationForTreatment &&
                <Box width={props.size === "xxsmall" ? "100%" : "60%" }>
                    <Layer >
                        <EvaluationForTreatment 
                            setShow={setShowEvaluationForTreatment} 
                            station={station}
                            stationStartRow={stationStartRow}
                            treatment={selectedTreatment}
                            setBestTreatmentNum={setBestTreatmentNum}
                            handleBestTreatment={{
                                bestNum: bestTreatmentNum,
                                bestBy: bestTreatmentBy,
                                updateBestAuto: updateBestTreatmentAuto,
                                cancelManualSelectionOfBest: cancelManualSelectionBestTreatment
                            }}
                            updatePlantStatus={{}}
                            deleteDisqualReason={deleteDisqualReason}
                            loadAllTreatmentsByStation={props.loadAllTreatmentsByStation}
                            />
                    </Layer>
                </Box>
                }

                <Box align="center" direction="row" gap="small" pad="small" justify="around">
                    <Button primary style={{color: "#ffffff"}} label="Close" onClick={()=>{props.setShowTreatments(false);}} />
                </Box>

            </Box>
            
        </Layer>
    );
  };
  
  export default TreatmentsListByStation;
  